import { BLOG_FRAGMENTS } from "./fragments/blog";
import { CART_FRAGMENTS } from "./fragments/cart";
import { COMMON_FRAGMENTS } from "./fragments/common";
import { CUSTOMER_FRAGMENTS } from "./fragments/customer";
import { METAOBJECT_FRAGMENTS } from "./fragments/metaobject";
import { ORDER_FRAGMENTS } from "./fragments/order";
import { PRODUCT_FRAGMENTS } from "./fragments/product";

const FRAGMENT_HEAD = /fragment\s+(\w+)\s+on\s+\w+[^{]*\{/g;
const FRAGMENT_SPREAD = /\.\.\.(\w+)/g;

/** 상수 하나에 fragment가 여러 개 들어있을 수 있으므로 정의 단위로 쪼갠다 (중괄호 균형 기준) */
function splitFragments(source: string): { name: string; definition: string }[] {
  const found: { name: string; definition: string }[] = [];

  for (const match of source.matchAll(FRAGMENT_HEAD)) {
    let depth = 0;
    let end = match.index;

    for (let i = match.index; i < source.length; i += 1) {
      if (source[i] === "{") depth += 1;
      else if (source[i] === "}") {
        depth -= 1;
        if (depth === 0) {
          end = i + 1;
          break;
        }
      }
    }

    found.push({ name: match[1], definition: `\n${source.slice(match.index, end)}\n` });
  }

  return found;
}

/** fragment 이름 → 정의 텍스트 */
const REGISTRY = new Map<string, string>();

const ALL_FRAGMENTS = [
  ...COMMON_FRAGMENTS,
  ...PRODUCT_FRAGMENTS,
  ...CART_FRAGMENTS,
  ...BLOG_FRAGMENTS,
  ...ORDER_FRAGMENTS,
  ...CUSTOMER_FRAGMENTS,
  ...METAOBJECT_FRAGMENTS,
];

for (const source of ALL_FRAGMENTS) {
  for (const { name, definition } of splitFragments(source)) REGISTRY.set(name, definition);
}

export function buildDocument(operation: string): string {
  const visitedNames = new Set<string>();
  const appended = new Set<string>();
  const parts: string[] = [];

  const collect = (text: string) => {
    for (const [, name] of text.matchAll(FRAGMENT_SPREAD)) {
      if (visitedNames.has(name)) continue;
      visitedNames.add(name);

      const definition = REGISTRY.get(name);
      if (!definition) throw new Error(`[shopifyV2] 등록되지 않은 fragment: ${name}`);

      // 한 상수에 fragment가 여러 개 들어있을 수 있으므로 텍스트 기준으로 중복 제거
      if (!appended.has(definition)) {
        appended.add(definition);
        parts.push(definition);
      }
      collect(definition);
    }
  };

  collect(operation);

  return operation + parts.join("");
}
